<template>
  <div class="main-menu">
    <div class="gs-logo" @click="$router.push({path: '/'}).catch(err => err)"></div>
    <ul class="tabs">
      <li class="per-tab"><router-link to="/"><i class="fa fa-home white-color">Home</i></router-link></li>
      <li class="per-tab"><router-link to="/about"><i class="fa fa-question-circle white-color">About</i></router-link></li>
      <li class="per-tab"><router-link to="/books"><i class="fa fa-book white-color">Books</i></router-link></li>
      <li class="per-tab"><router-link to="/booksDb"><i class="fa fa-database white-color">BooksDb</i></router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MainMenu'
}
</script>

<style scoped>
.main-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.gs-logo {
  display: inline-block;
  float:left;
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  background-image: url(../assets/logo.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.tabs {
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: rgba(0, 0, 0, 1);
}
.per-tab:hover {
    color: #787878;
    background-color: rgba(255, 255, 255, .8);
  }
.per-tab {
  display: inline-block;
  width: 120px;
  line-height: 32px;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.per-tab:last-child {
  border-right: 1px solid #ccc;
}
.white-color {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue